<template>
  <div>
    <div class="personal">
      <div class="nav">
        <div class="ban">
          <ul class="nav-top">
            <li v-for="item in tabList" :key="item.id" @click="changes(item)">
              <span>{{ item.text }}</span>
              <i :class="checked === item.id ? 'checked' : ''"></i>
            </li>
          </ul>
        </div>
      </div>
      <div class="ban">
        <evaluate ref="luate"  ></evaluate>

      </div>
    </div>
  </div>
</template>

<script>
import personInfo from "../../components/personal/info";
import cost from "../../components/personal/cost";
import personOrder from "../../components/personal/order";
import evaluate from "../../components/personal/evaluate";
// import { getusername } from "../../api/myAuth";
import members from "../../components/personal/members.vue";
import inquiry from "@/components/personal/inquiry";
export default {
  name: "Personal",
  components: {
    personInfo,
    cost,
    personOrder,
    evaluate,
    members,
    inquiry,
  },
  data() {
    return {
      checked: 0,
      nav: [
        {
          id: 0,
          text: "我的投诉",
        }
      ],
      userType: 0,
    };
  },
  computed: {
    tabList() {
      if (this.userType === 0) {
        return this.nav.slice(0, 4);
      } else {
        return this.nav;
      }
    },
  },
  created() {
    let userObj = JSON.parse(window.sessionStorage.getItem("userInfo"));
    if (userObj === null) {
      this.$message.warning("请先登录！");
      this.$router.push({ path: "/login" });
      return;
    }
    // let obj = JSON.parse(window.sessionStorage.getItem("currentInfo"));
    // if (obj) {
    //   this.userType = obj.userType;
    //   if (this.userType !== 0) {
    //     this.nav[3].text = "客户投诉";
    //   }
    // }
    console.log(this.$route.params.checked);
    let id = this.$route.params.checked;
    if (id) {
      this.checked = id;
    }

  },
  mounted() {

  },
  methods: {
    // 投诉跳转
    orderCome() {
      console.log("触发了父组件事件");
      this.checked = 3;
      this.$refs.luate.getcomplaint();
    },
    // 动态添加下标
    changes(item) {
      this.checked = item.id;
      this.$refs.evaluate.replace();
    },
  },
};
</script>

<style lang="scss" scoped>
.personal {
  width: 100%;
  background-color: #f8f8f8;
  .nav {
    width: 100%;
    background-color: #0289f2;
    .nav-top {
      display: flex;
      li {
        width: 160px;
        font-size: 16px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        position: relative;
        cursor: pointer;
        .checked {
          width: 12px;
          height: 8px;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin: 0 auto;
          background: url("../../static/imgs/icon_triangle_white.png") no-repeat
          center;
          background-size: cover;
        }
      }
      .yinyou {
        width: 160px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background-color: #047bd7;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // .img {
        //   display: block;
        //   width: 98px;
        //   height: 23px;
        //   background: url("../../static/imgs/personalCenter/mineyy.png")
        //     no-repeat center;
        // }
        .myMember {
          display: block;
          font-size: 20px;
          font-weight: 700;
          color: #fff;
        }
      }
    }
  }
  .ban {
    width: 1500px;
    margin: 0 auto;
    font-size: 16px;
  }
}
</style>
